const initialState = {
  branchList: [],
  notificationEmailTypeList: [
    { type: 'register', name: 'registerSolicitation' },
    { type: 'contact', name: 'projectsForIntegrators' },
    { type: 'project', name: 'projectsDirectory' },
    { type: 'courses', name: 'coursesAndTraining' },
    { type: 'technicalMaterial', name: 'technicalMaterial' },
    { type: 'getnetPayment', name: 'getnetPayment' },
  ],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_BRANCH_LIST':
      return { ...state, branchList: [...action.branchList] };
    default:
      return state;
  }
};
